'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import formatCurrencyWithCode from '../utils/formatCurrencyWithCode';
export default class FormattedCurrency extends Component {
  render() {
    const _this$props = this.props,
          {
      abbreviate,
      abbreviateThreshold,
      value,
      simplifyCurrency,
      stripInsignificantZeros,
      useCurrencyCode
    } = _this$props,
          options = _objectWithoutPropertiesLoose(_this$props, ["abbreviate", "abbreviateThreshold", "value", "simplifyCurrency", "stripInsignificantZeros", "useCurrencyCode"]);

    if (simplifyCurrency && value % 1 === 0) {
      options.precision = 0;
    }

    if (useCurrencyCode) {
      options.unit = '';
      options.useCurrencyCode = true;
    }

    if (stripInsignificantZeros === false) {
      options.strip_insignificant_zeros = false;
    } else {
      options.strip_insignificant_zeros = true;
    }

    const wrapperAttributes = {};

    if (abbreviate && (typeof abbreviateThreshold !== 'number' || typeof abbreviateThreshold === 'number' && value >= abbreviateThreshold)) {
      wrapperAttributes.title = I18n.formatCurrency(value, options);
      options.abbreviate = true;
      options.precision = 0;
    }

    const formattedNumber = I18n.formatCurrency(value, options);
    const numberToRender = useCurrencyCode ? formatCurrencyWithCode(formattedNumber, options.currencyCode) : formattedNumber;
    return /*#__PURE__*/_jsx("span", Object.assign({}, wrapperAttributes, {
      children: numberToRender
    }));
  }

}
FormattedCurrency.displayName = 'FormattedCurrency';
FormattedCurrency.propTypes = {
  abbreviate: PropTypes.bool,
  abbreviateThreshold: PropTypes.number,
  maxFractionDigits: PropTypes.number,
  currencyCode: PropTypes.string,
  precision: PropTypes.number,
  simplifyCurrency: PropTypes.bool,
  stripInsignificantZeros: PropTypes.bool,
  unit: PropTypes.string,
  useCurrencyCode: PropTypes.bool,
  value: PropTypes.number.isRequired,
  formatNegativeValuesWithParenthesis: PropTypes.bool
};
FormattedCurrency.defaultProps = {
  stripInsignificantZeros: false,
  simplifyCurrency: false,
  formatNegativeValuesWithParenthesis: false
};